class Carousel extends HTMLElement {
  constructor() {
    super();
    this.listContainer = this.querySelector('.carousel-list');
    this.querySelector('.slider-button--prev').addEventListener('click', this.scrollToPreviousItem.bind(this));
    this.querySelector('.slider-button--next').addEventListener('click', this.scrollToNextItem.bind(this));
  }

  _elementIsVisible(el) {
    const { left, width, right } = el.getBoundingClientRect();
    const rect = this.listContainer.getBoundingClientRect();
    return left <= rect.left ? rect.left - left <= width : right - rect.right <= width;
  }

  scrollToPreviousItem() {
    let lastHiddenElement;
    for (let i = 0; i < this.listContainer.children.length; i++) {
      if (this._elementIsVisible(this.listContainer.children[i])) {
        break;
      }
      lastHiddenElement = this.listContainer.children[i];
    }
    if (lastHiddenElement) {
      this._scrollIntoViewHorizontally(lastHiddenElement, this.listContainer);
    }
  }

  scrollToNextItem() {
    let lastHiddenElement;
    for (let i = this.listContainer.children.length - 1; i >= 0; i--) {
      if (this._elementIsVisible(this.listContainer.children[i])) {
        break;
      }
      lastHiddenElement = this.listContainer.children[i];
    }
    if (lastHiddenElement) {
      this._scrollIntoViewHorizontally(lastHiddenElement, this.listContainer);
    }
  }

  _scrollIntoViewHorizontally(element, container) {
    if (container.scrollLeft > element.offsetLeft) {
      container.scrollLeft = element.offsetLeft - container.offsetLeft;
      return;
    }
    const offsetRight = element.offsetLeft + element.offsetWidth;
    const containerScrollRight = container.scrollLeft + container.offsetLeft + container.offsetWidth;
    if (containerScrollRight < offsetRight) {
      container.scrollLeft += offsetRight - containerScrollRight;
    }
  }
}

customElements.define('carousel-list', Carousel);
